import styled from 'styled-components';

const ContainerHome = styled.section`
margin: 0 auto;

@media only screen and (max-width: 1320px) {
}
`;

export default ContainerHome;